/**
 * 商品详情api
 */
import CommonApi from 'api/common.js';
var api = {
  selectMallGoodsInfo: function selectMallGoodsInfo(params) {
    return CommonApi.post('/dayaotex-server-goods/goods/selectMallGoodsInfo', params);
  },
  selectUpstreamGoods: function selectUpstreamGoods(params) {
    return CommonApi.post('/dayaotex-server-goods/goods/selectUpstreamGoods', params);
  },
  selectDownstreamGoods: function selectDownstreamGoods(params) {
    return CommonApi.post('/dayaotex-server-goods/goods/selectDownstreamGoods', params);
  },
  selectGoodsBrother: function selectGoodsBrother(params) {
    return CommonApi.post('/dayaotex-server-goods/goods/selectGoodsBrother', params);
  },
  selectDetailedContentByGoodsId: function selectDetailedContentByGoodsId(params) {
    return CommonApi.post('/dayaotex-server-goods/goods/selectDetailedContentByGoodsId', params);
  },
  selectGoodsQualityLatest: function selectGoodsQualityLatest(params) {
    return CommonApi.post('/dayaotex-server-goods/batch/selectGoodsQualityLatest', params);
  },
  addShopCar: function addShopCar(params) {
    return CommonApi.post('/dayaotex-server-order/addShopCar', params);
  },
  buyNow: function buyNow(params) {
    return CommonApi.post('/dayaotex-server-order/buyNow', params);
  },
  selectAppGoodsBrother: function selectAppGoodsBrother(params) {
    return CommonApi.post('dayaotex-server-goods/goods/selectAppGoodsBrother', params);
  },
  selectGoodsMLDetails: function selectGoodsMLDetails(params) {
    return CommonApi.post('/dayaotex-server-goods/goodsTemplate/goodsMLDetails', params);
  },
  addGoodsClicksStatistics: function addGoodsClicksStatistics(params) {
    return CommonApi.post('/dayaotex-server-goods/goods/addGoodsClicksStatistics', params);
  }
};
export default api;